<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-12">
    <h2>
      Liste des utilisateurs
      <span *ngIf="archives">archivés / bloqués</span> ({{ totalItems }})
    </h2>
  </div>
</div>

<div *ngIf="duplicates?.length > 0" class="row m-t-sm">
  <div class="col-lg-12">
    <div class="alert alert-warning" role="alert">
      <h4 class="alert-heading">NIP dupliqué !</h4>
      <ul>
        @for(u of duplicates; track u) {
          <li>{{u.fullname}} @if(u.blocked){<span>(Archivé)</span>} - Nip: {{u.nip}}</li>
        }
      </ul>
      <hr>
      <span>Veuillez modifier le NIP</span>
    </div>
  </div>
</div>

<div class="row m-t-sm">
  <div class="col-lg-12">
    <div class="row">
      <div class="col-lg-6">
        <pagination
          class="d-none d-md-block"
          (numPages)="smallnumPages = $event"
          (pageChanged)="pageChanged($event)"
          [(ngModel)]="currentPage"
          [directionLinks]="true"
          [itemsPerPage]="30"
          [totalItems]="totalItems"
          nextText="Suivant"
          previousText="Précédent"
        >
        </pagination>
      </div>
      <div class="col-lg-3">
        <div class="form-group">
          <div class="input-group">
            <input
              #search
              (keyup.enter)="filterByLastname(search.value)"
              class="form-control"
              placeholder="Nom de famille, courriel, nip"
              type="text"
            />
            <span class="input-group-btn">
              <button
                (click)="filterByLastname(search.value)"
                class="btn btn-primary btn-lg"
              >
                <i class="far fa-filter"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="d-none d-md-block">
          <button
            tooltip="Ajouter un utilisateur"
            (cancel)="nothing()"
            (confirm)="createUser($event)"
            [swal]="{
              title: 'Ajouter un utilisateur',
              icon: 'info',
              text: 'NIP de la personne',
              input: 'text',
              showCancelButton: true,
              cancelButtonText: 'Annuler',
              confirmButtonText: 'Ajouter',
              animation: false
            }"
            class="btn btn-primary btn-lg"
          >
            <i class="fal fa-plus"></i>
          </button>
          &nbsp;
          <button
            tooltip="Voir les archives"
            (click)="toggleArchives()"
            [ngClass]="!archives ? 'btn-primary' : 'btn-warning'"
            class="btn btn-lg"
          >
            <em class="far fa-archive"></em>
          </button>
          &nbsp;
          @if(loggedUser.isRoot()) {
            <button
              (cancel)="nothing()"
              (confirm)="importEcawin()"
              [swal]="{
              icon: 'warning',
              title: 'Mise à jour des utilisateurs.',
              text: 'Cette action ne peut pas être annulée.',
              showCancelButton: true,
              cancelButtonText: 'Annuler',
              confirmButtonText: 'Oui, je veux importer'
            }"
              class="btn btn-warning btn-lg"
              tooltip="Import des utilisateurs"
            >
              <em class="far fa-file-import"></em>
            </button>
          }
        </div>
      </div>
    </div>

    <table class="table table-hover table-responsive">
      <thead>
      <tr>
        <th (click)="sortBy('lastname')">
          Nom
          @if(sortColumn == 'lastname') {
            <span>
            @if(sortDirection == 'ASC') {
                <i class="far fa-sort-up"></i>
            } @else if (sortDirection == 'DESC') {
                <i class="far fa-sort-down"></i>
            }
            </span>
          }

        </th>
        <th (click)="sortBy('firstname')">
          Prénom
          @if(sortColumn == 'firstname') {
            <span>
            @if(sortDirection == 'ASC') {
              <i class="far fa-sort-up"></i>
            } @else if (sortDirection == 'DESC') {
              <i class="far fa-sort-down"></i>
            }
            </span>
          }
        </th>
        <th (click)="sortBy('rank')">
          Grade
          @if(sortColumn == 'rank') {
            <span>
            @if(sortDirection == 'ASC') {
              <i class="far fa-sort-up"></i>
            } @else if (sortDirection == 'DESC') {
              <i class="far fa-sort-down"></i>
            }
            </span>
          }
        </th>
        <th>Courriel</th>
        <th (click)="sortBy('site.name')">
          OI
          @if(sortColumn == 'site.name') {
            <span>
            @if(sortDirection == 'ASC') {
              <i class="far fa-sort-up"></i>
            } @else if (sortDirection == 'DESC') {
              <i class="far fa-sort-down"></i>
            }
            </span>
          }
        </th>
        <th>Nip</th>
        <th>Num. Perso.</th>
        <th (click)="sortBy('lastConnection')">
          Dernière connexion
          @if(sortColumn == 'lastConnection') {
            <span>
            @if(sortDirection == 'ASC') {
              <i class="far fa-sort-up"></i>
            } @else if (sortDirection == 'DESC') {
              <i class="far fa-sort-down"></i>
            }
            </span>
          }
        </th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      @for(user of users; track user) {
        <tr
          [ngClass]="user.status === 'BLOCKED' ? 'warning' : ''"
        >
          @if(editRow == user) {
            <td>
              <input
                [(ngModel)]="user.lastname"
                class="form-control"
                type="text"
              />
            </td>
            <td>
              <input
                [(ngModel)]="user.firstname"
                class="form-control"
                type="text"
              />
            </td>
            <td>
              <input [(ngModel)]="user.rank" class="form-control" type="text"/>
            </td>
            <td>
              <input
                [(ngModel)]="user.username"
                class="form-control"
                type="text"
              />
            </td>

            <td>
              <select [(ngModel)]="user.site" [compareWith]="compareSitesById" class="form-control">
                @for(site of sites; track site) {
                  <option  [ngValue]="site">{{site.name}}</option>
                }
              </select>
            </td>
            <td>
              <input [(ngModel)]="user.nip" class="form-control" type="text"/>
            </td>
            <td>
              <input
                [(ngModel)]="user.personalNumber"
                class="form-control"
                type="text"
              />
            </td>
            <td class="d-none d-md-block">{{ user.lastConnection }}</td>
            <td>
              <button (click)="save(user)" class="btn btn-primary">
                <i class="far fa-save"></i>
              </button>
              <button (click)="cancel()" class="btn btn-default">
                <i class="far fa-ban"></i>
              </button>
            </td>
          }
          @if(editRow != user) {
            <td>{{ user.lastname }}</td>
            <td>{{ user.firstname }}</td>
            <td>{{ user.rank }}</td>
            <!--'2017,5,15,20,42,57,457000000'-->
            <td class="d-none d-md-block">{{ user.username }}</td>
            <td>{{ user.site?.name }}</td>
            <td>{{ user.nip }}</td>
            <td>{{ user.personalNumber }}</td>
            <td>
              <ng-container class="d-none d-md-block">
                {{ user.lastConnection | date: 'd MMM yyyy' }}
                @if(user.lastConnection) {
                  <span>({{ user.lastConnection | amLocale: 'fr' | amTimeAgo }})</span>
                }
              </ng-container>
            </td>
            <td>
              @if(loggedUser.isAuthorized('OP_USERS_MANAGEMENT')) {
                <button
                  (cancel)="nothing()"
                  (confirm)="updatePassword(user, $event)"
                  [swal]="{showCancelButton: true, icon: 'info', input: 'password', text: 'Le mot de passe ne sera pas synchronisé avec l\'ECA', title: 'Forcer un mot de passe local'}"
                  class="m-xxs btn btn-default"
                  tooltip="Changer le mot de passe"
                >
                  <em class="fal fa-key"></em>
                </button>
                <button
                  (click)="togglLdap(user)"
                  [ngClass]="user.ldap ? 'btn-default' : 'btn-danger'"
                  class="m-xxs btn"
                  tooltip="Activer/désactiver LDAP"
                >
                  Connexion ECA <em *ngIf="!user.ldap" class="fal fa-ban"></em>
                </button>
                <button
                  [routerLink]="['../permissions', user.id]"
                  class="m-xxs btn btn-default"
                  tooltip="Voir les permissions de cet utilisateur"
                >
                  Rôles
                </button>
              }

              @if(loggedUser.isAuthorized('OP_IMPERSONATE')) {
                <button
                  (click)="impersonate(user)"
                  [disabled]="user.isAuthorized('ROLE_ROOT')"
                  class="m-xxs btn btn-default"
                  tooltip="Se connecter en tant que cet utilisateur"
                >
                  <i class="far fa-eye"></i>
                </button>
              }
              <button
                (click)="edit(user)"
                [disabled]="user.isAuthorized('ROLE_ROOT')"
                class="m-xxs btn btn-default"
                tooltip="Editer cet utilisateur"
              >
                <i class="fas fa-edit"></i>
              </button>

              @if(loggedUser.isAuthorized('OP_MESSAGES_ADMIN')) {
                <button
                  [routerLink]="['/tags', user.id]"
                  class="m-xxs btn btn-default"
                  tooltip="Voir les tags pour cet utilisateur"
                >
                  <i class="far fa-tag"></i>
                </button>
              }

              @if(!user.blocked) {
                <button
                  (click)="lock(user)"
                  [disabled]="user.isAuthorized('ROLE_ROOT')"
                  class="m-xxs btn btn-default"
                  tooltip="Bloquer cet utilisateur"
                >
                  <i class="far fa-unlock"></i>
                </button>
              }
              @else if(user.blocked) {
                <button
                  (click)="unlock(user)"
                  [disabled]="user.isAuthorized('ROLE_ROOT')"
                  class="m-xxs btn btn-warning"
                  tooltip="Débloquer cet utilisateur"
                >
                  <i class="far fa-lock"></i>
                </button>
              }
            </td>
          }
        </tr>
      }

      </tbody>
    </table>
  </div>
</div>
